import * as React from "react";
import { observer } from "mobx-react";

import { UitkCardAloha, UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkLayoutGrid, UitkLayoutGridColumnRow } from "uitk-react-layout-grid";

import Link from "./components/Link";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { CrossLOBLinksProps } from "./typings";
import { withStores } from "src/stores";

import { CrossLobLinksFlexModuleResult } from "typings/microserviceModels/cross-lob-links-flex-module";
import { LazyLoad } from "src/components/utility/LazyLoad/LazyLoad";

export const CrossLOBLinks = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: CrossLOBLinksProps) => {
    const { flexTemplateNode, flexModuleModelStore, context } = props;
    const { id, options } = flexTemplateNode;
    const model = flexModuleModelStore.getModel(id) as CrossLobLinksFlexModuleResult | null;

    /* istanbul ignore next */
    if (!model) {
      return null;
    }

    const { links, title, description, displayColumns } = model;

    if (!links?.length) {
      return null;
    }

    const DEFAULT_MOBILE_DISPLAY_COLUMNS = 1;
    const columns = {
      small: DEFAULT_MOBILE_DISPLAY_COLUMNS as UitkLayoutGridColumnRow,
      large: Number(displayColumns) as UitkLayoutGridColumnRow,
    };

    const keyHelper = new ItemKeyHelper("CrossLOBLinks");

    return (
      <LazyLoad context={context}>
        <div
          id={id}
          className="CrossLOBLinks all-t-padding-three"
          data-fm={options.fmId}
          data-fm-title-id={options.fmTitleId}
        >
          <UitkCardAloha>
            <UitkCardAlohaContentSection>
              {title && (
                <UitkHeading level={2} size={600}>
                  {title}
                </UitkHeading>
              )}

              {description && <UitkText spacing="two">{description}</UitkText>}

              <UitkLayoutGrid columns={columns} space="one" className="all-t-margin-two">
                {links.map((link) => (
                  <Link key={keyHelper.next()} link={link} />
                ))}
              </UitkLayoutGrid>
            </UitkCardAlohaContentSection>
          </UitkCardAloha>
        </div>
      </LazyLoad>
    );
  })
);

// This map contains the mapping for the icon types from the backend response to corresponding UitkIcon
export const iconMap = {
  flights: "lob_flights",
  house: "lob_vacation_rentals",
  hotels: "lob_hotels",
  cars: "lob_cars",
  packages: "lob_packages",
  activities: "lob_activities",
};

export default CrossLOBLinks;
